import React from 'react'

import styles from './modal.module.css'

const Modal = ({ show = false, children, onClose }) => {
    if (!show) return null;

    return (
        <div className={styles.modalBackground} onClick={onClose}>
            <div
                className={styles.modalContainer}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    )
}

export const withModal = (Component) => (props) => {
    return (
        <Modal {...props}>
            <Component {...props}/>
        </Modal>
    )
}

export default Modal 